function setMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function applySeo(settings: Record<string, unknown>) {
  const title = String(settings.seo_title || "MARK DIRECT COMPANY");
  const description = String(settings.seo_description || "");
  const keywords = String(settings.seo_keywords || "");
  const ogImage = String(settings.seo_og_image || "");
  const twitterImage = String(settings.seo_twitter_image || "");
  const robots = String(settings.seo_robots || "index, follow");
  const favicon = String(settings.favicon_url || "");

  document.title = title;
  setMeta("name", "description", description);
  setMeta("name", "keywords", keywords);
  setMeta("name", "robots", robots);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  if (ogImage) setMeta("property", "og:image", ogImage);
  setMeta("name", "twitter:title", title);
  setMeta("name", "twitter:description", description);
  if (twitterImage) setMeta("name", "twitter:image", twitterImage);

  if (favicon) {
    let link = document.head.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = favicon;
  }
}